// Subida de assets compartida entre el LeftPanel y el modo Simple del Studio.
// Antes vivia solo dentro del LeftPanel; extraida para que el slot de foto de
// una receta use exactamente el mismo camino (downscale + createAsset) sin
// duplicar la logica.
import { api } from './api';
import { downscaleToDataUrl } from './img';

export async function uploadAssetFile(file, type) {
  const dataUrl = await downscaleToDataUrl(file, 1280);
  return api.createAsset({ type, name: file.name.replace(/\.[^.]+$/, ''), dataUrl });
}
